import angular from 'angular';

const STORAGE_KEY = 'data';

export default class DataService {
  /* @ngInject */
  constructor(localStorageService) {
    let localData = localStorageService
      .get(STORAGE_KEY);

    if (localData) {
      localData = angular.fromJson(localData);
    }

    this.localStorageService = localStorageService;
    this.data = localData || {};
  }

  getData() {
    return Object.assign({}, this.data);
  }

  extendData(data = {}) {
    const extendedData = Object.assign({}, this.data, data);

    if (!angular.equals(extendedData, this.data)) {
      this.setData(extendedData);
    }
  }

  setData(data = {}) {
    this.data = data;
    this.localStorageService.set(STORAGE_KEY, angular.toJson(this.data));
  }

  clearData() {
    this.data = {};
    this.localStorageService.clearAll();
  }


  clearSolutions() {
    this.extendData({
      solutions: undefined
    });
  }

  validate(config) {
    let valid = true;

    if (this.data.solutions) {
      valid = Object
        .keys(this.data.solutions)
        .every(solution => config.SolutionDictionary[solution]);
    }

    return valid;
  }
}




// WEBPACK FOOTER //
// ./src/services/data.service.js